import React, { useContext, useState, useEffect } from 'react';
import {
    USBNavBar,
    USBNavBrand,
    USBNavCollapse,
    USBNavLink,
    USBNavList,
    USBNavListItem,
    USBNavRoot,
    USBNavSub,
    USBNavSubCloseButton,
    USBNavSubTrigger,
    USBNavTrigger,
    USBNavTriggerIcon,
    USBNavTooltip
} from '@usb-shield/addon-react-navigation';
import logo from '../../../assets/images/usbank.png';
import { USBGrid, USBColumn } from '@usb-shield/components-react';


import {
    USBContainer,
    USBText
} from '@usb-shield/addon-react-primitives';

import './navmenu.css';
import '../TopMenu/topmenu.css';
import { DocContext } from '../../../pages/context/DocContext';
import { PermissionRoleContext } from '../../Hooks/usePermissionRoles';
import { FeatureFlagsContext } from '../../Hooks/useFeatureFlags';
import { AssignedTeamMembers } from '../TopMenu/TopMenu';
import useUserRole from '../../Hooks/use-UserRole';
import { useNavigate } from 'react-router-dom';
import TopLink from '../../../components/atoms/TopLink/TopLink';

const NavMenu = ({ onLogout }) => {
    const navigate = useNavigate();
    const userCheck = useUserRole();
    const { permissionDetails } = useContext(PermissionRoleContext);
    const { featureDetails } = useContext(FeatureFlagsContext);
    const {
        notification,
        userName,
        userType,
        servicingUserRole,
        currentMenu,
        getNotificationCount,
        assignedUserName,
        getAssignedserName,
        listNotifications,
    } = useContext(DocContext);

    const [contentOpen, setContentOpen] = useState(false);

    useEffect(() => {
        const handleClickDropdown = (event) => {
            if (
                event.srcElement.className !== 'dropdown-element' &&
                event.srcElement.className !== 'dropdown-each'
            ) {
                setContentOpen(false);
            }
        };
        document.addEventListener('click', handleClickDropdown, true);
        return () => document.removeEventListener('click', handleClickDropdown, true);
    }, []);

    const closeMainNavIfCollapsed = () => {
        if (!window.matchMedia('(max-width: 1023px)').matches) return;

        const trigger =
            document.querySelector('[data-testid="trigger--main"][aria-expanded="true"]') ||
            document.querySelector('[data-testid="trigger--main"] [aria-expanded="true"]') ||
            document.querySelector('[data-testid="trigger--main"]');

        const isExpanded =
            trigger?.getAttribute?.('aria-expanded') === 'true' ||
            trigger?.querySelector?.('[aria-expanded="true"]');

        if (isExpanded && typeof trigger?.click === 'function') {
            trigger.click();
        }
    };

    const gotoManageUsers = () => {
        navigate('/ManageUser');
        window.location.reload();
    };

    const gotoInbox = () => {
        if (
            sessionStorage.getItem('remote_user') &&
            JSON.parse(sessionStorage.getItem('remote_user'))?.onlyPortfolio
        ) {
            if (confirm("Are you sure you want to navigate to Inbox page? This will reset view to your profile if you were impersonating any user/viewing another user's profile.") == true) {
                sessionStorage.setItem('assignedUser', sessionStorage.getItem('loggedUser'));
                sessionStorage.removeItem('remote_user');
                navigate('/Inbox');
            }
        } else {
            navigate('/Inbox');
        }
    };

    const gotoContacts = () => {
        navigate('/Contacts');
    };

    const gotoMyPortfolio = () => {
        if (
            sessionStorage.getItem('remote_user') &&
            JSON.parse(sessionStorage.getItem('remote_user'))?.onlyInbox
        ) {
            if (confirm("Are you sure you want to navigate to Portfolio page? This will reset view to your profile if you were impersonating any user/viewing another user's profile.") == true) {
                sessionStorage.setItem('assignedUser', sessionStorage.getItem('loggedUser'));
                sessionStorage.removeItem('remote_user');
                navigate('/ReportingDashboard');
            }
        } else {
            navigate('/ReportingDashboard');
        }
    };

    const gotoDocTemplates = () => {
        navigate('/DocumentTemplate');
    };

    const exitImpersonate = () => {
        sessionStorage.removeItem('remote_user');
        sessionStorage.removeItem('sessionFilters');
        window.location.href = '/Welcome';
    };

    const gotoReport = (e, path) => {
        e.preventDefault();
        closeMainNavIfCollapsed();
        const target = e.currentTarget;
        setTimeout(() => target.blur(), 0);
        window.location.pathname === path ? window.location.reload() : navigate(path);
    };

    const gotoTool = (e, path) => {
        e.preventDefault();
        closeMainNavIfCollapsed();
        const target = e.currentTarget;
        setTimeout(() => target.blur(), 0);
        window.location.pathname === path ? window.location.reload() : navigate(path);
    };

    const gotoCB = (e, path) => {
        e.preventDefault();
        closeMainNavIfCollapsed();
        const target = e.currentTarget;
        setTimeout(() => target.blur(), 0);
        if (sessionStorage.getItem('remote_user')) {
            if (confirm("Are you sure you want to navigate to Closing Binders page? This will reset view to your profile if you were impersonating any user/viewing another user's profile.") == true) {
                sessionStorage.setItem('assignedUser', sessionStorage.getItem('loggedUser'));
                sessionStorage.removeItem('remote_user');
                window.location.pathname === path ? window.location.reload() : navigate(path);
            }
        } else {
            window.location.pathname === path ? window.location.reload() : navigate(path);
        }
    };

    const navClick = (e, fn, { closeMainNav = false } = {}) => {
        e.preventDefault();
        if (closeMainNav) closeMainNavIfCollapsed();
        fn();
    };

    return (
        <>

            <header data-testid="anatomy-header" className='nav-header'>
                <USBNavRoot
                    data-testid="root"
                    expand="lg"
                >
                    <USBGrid addClasses="top-menu">
                        <USBColumn largeSpan={2} />
                        <USBColumn largeSpan={12}>
                            <USBContainer
                                data-testid="region--utility"
                                fluid
                                className="utility-inline-row"
                            >
                                <USBNavBar
                                    ariaLabel="Utility"
                                    data-testid="navbar--utility"
                                    display={{ base: 'flex', lg: 'flex' }}
                                    marginRight={{ base: 'auto', sm: 'auto' }}
                                >
                                    <USBNavList data-testid="navlist--utility">

                                        {/* Greeting */}
                                        {userName?.firstName && (
                                            <USBNavListItem display={{ base: 'flex', lg: 'flex' }}>
                                                <span className="top-nav-greeting" style={{ padding: '0 8px', marginRight: '12px', alignSelf: 'center' }}>
                                                    {`Hi, ${userName.firstName.charAt(0).toUpperCase() + userName.firstName.slice(1)}`}
                                                </span>
                                            </USBNavListItem>
                                        )}

                                        {/* Viewing as — employees only */}
                                        {userType === 'employee' && userCheck === 'employee' && (
                                            <USBNavListItem display={{ base: 'flex', lg: 'flex' }}>
                                                <AssignedTeamMembers
                                                    contentOpen={contentOpen}
                                                    setContentOpen={setContentOpen}
                                                    getNotificationCount={getNotificationCount}
                                                    assignedUserName={assignedUserName}
                                                    getAssignedserName={getAssignedserName}
                                                    listNotifications={listNotifications}
                                                    currentMenu={currentMenu}
                                                />
                                            </USBNavListItem>
                                        )}

                                        {/* Notifications */}
                                        {!(permissionDetails?.includes('inbox') && !permissionDetails?.includes('portfolio')) && (
                                            <USBNavListItem display={{ base: 'flex', lg: 'flex' }}>
                                                <TopLink
                                                    href="/Notifications"
                                                    title="Notifications"
                                                    text="Notifications"
                                                    notification={notification + ''}
                                                />
                                            </USBNavListItem>
                                        )}

                                        {/* My Profile — non-employees */}
                                        {userType !== 'employee' && (
                                            <USBNavListItem display={{ base: 'flex', lg: 'flex' }}>
                                                <USBNavLink href="/MyProfile" data-testid="navlink--profile">
                                                    My Profile
                                                </USBNavLink>
                                            </USBNavListItem>
                                        )}

                                        {/* Exit User */}
                                        {sessionStorage.getItem('remote_user') && (
                                            <USBNavListItem display={{ base: 'flex', lg: 'flex' }}>
                                                <USBNavLink
                                                    data-testid="navlink--exit-user"
                                                    href="#"
                                                    className={'black-font'}
                                                    onClick={(e) => navClick(e, exitImpersonate)}
                                                >
                                                    Exit User
                                                </USBNavLink>
                                            </USBNavListItem>
                                        )}

                                        {/* Log Out */}
                                        <USBNavListItem display={{ base: 'flex', lg: 'flex' }}>
                                            <USBNavLink
                                                data-testid="navlink--logout"
                                                href="#"
                                                className={'black-font'}
                                                onClick={(e) => navClick(e, onLogout)}
                                            >
                                                Log Out
                                            </USBNavLink>
                                        </USBNavListItem>

                                    </USBNavList>
                                </USBNavBar>

                                <USBNavTrigger
                                    ariaLabel="Main Menu"
                                    data-testid="trigger--main"
                                >
                                    <USBNavTriggerIcon />
                                </USBNavTrigger>
                            </USBContainer>
                        </USBColumn>
                        <USBColumn largeSpan={2} />
                    </USBGrid>
                    {/* Main nav collapse — all primary links */}
                    <USBGrid addClasses="blue-frame top-menu">
                        <USBColumn largeSpan={2} />
                        <USBColumn largeSpan={12}>
                            <USBNavCollapse data-testid="region--main" style={{ backgroundColor: 'transparent', width:'stretch', zIndex:"2 !important" }}>
                                <USBNavBar
                                    ariaLabel="Main"
                                    data-testid="navbar--main"
                                    marginRight={{ base: null, lg: 'auto' }}
                                    size="small"
                                    style={{ backgroundColor: 'transparent', width: 'fit-content' }}
                                >
                                    <USBNavList data-testid="navlist--main">

                                        {/* Brand */}
                                        <USBNavListItem>
                                            <USBNavLink href="#">
                                                <div className="logo" role="img" aria-label="US Bank Logo">
                                                    <img src={logo}></img>
                                                </div>
                                            </USBNavLink>
                                        </USBNavListItem>

                                        {/* Home */}
                                        {['feature_landing_page_visible'].some(cb => featureDetails?.includes(cb)) && (
                                            <USBNavListItem>
                                                <USBNavLink
                                                    data-testid="home-link"
                                                    href="#"
                                                    isActive={currentMenu === 'home'}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        closeMainNavIfCollapsed();
                                                        window.location.href = '/Welcome';
                                                    }}
                                                >
                                                    Home
                                                </USBNavLink>
                                            </USBNavListItem>
                                        )}

                                        {/* My Portfolio */}
                                        {['portfolio'].some(cb => permissionDetails?.includes(cb)) && (
                                            <USBNavListItem>
                                                <USBNavLink
                                                    data-testid="portfolio-link"
                                                    href="#"
                                                    isActive={currentMenu === 'portfolio'}
                                                    onClick={(e) => navClick(e, gotoMyPortfolio, { closeMainNav: true })}
                                                >
                                                    My Portfolio
                                                </USBNavLink>
                                            </USBNavListItem>
                                        )}

                                        {/* Closing Binders */}
                                        {userCheck === 'employee' &&
                                            ['cbportfolio', 'cbdoctype', 'cbfilenettype'].some(cb => permissionDetails?.includes(cb)) && (
                                                <USBNavListItem data-testid="cb-link">
                                                    <USBNavSubTrigger>
                                                        Closing Binders
                                                    </USBNavSubTrigger>
                                                    <USBNavSub>
                                                        <USBNavSubCloseButton>Back</USBNavSubCloseButton>
                                                        <USBText as="h2">Closing Binders</USBText>
                                                        <USBNavList>
                                                            {permissionDetails?.includes('cbportfolio') && (
                                                                <USBNavListItem>
                                                                    <USBNavLink href="/ClosingBinders/Portfolio" className={'black-font'} onClick={(e) => gotoCB(e, '/ClosingBinders/Portfolio')}>
                                                                        CB Portfolio
                                                                    </USBNavLink>
                                                                </USBNavListItem>
                                                            )}
                                                            {permissionDetails?.includes('cbdoctype') && (
                                                                <USBNavListItem>
                                                                    <USBNavLink href="/ClosingBinders/Doctype" className={'black-font'} onClick={(e) => gotoCB(e, '/ClosingBinders/Doctype')}>
                                                                        CB Doctype
                                                                    </USBNavLink>
                                                                </USBNavListItem>
                                                            )}
                                                            {permissionDetails?.includes('cbfilenettype') && (
                                                                <USBNavListItem>
                                                                    <USBNavLink href="/ClosingBinders/Filenettype" className={'black-font'} onClick={(e) => gotoCB(e, '/ClosingBinders/Filenettype')}>
                                                                        CB FileNettype
                                                                    </USBNavLink>
                                                                </USBNavListItem>
                                                            )}
                                                        </USBNavList>
                                                    </USBNavSub>
                                                </USBNavListItem>
                                            )}

                                        {/* Inbox */}
                                        {['inbox'].some(cb => permissionDetails?.includes(cb)) &&
                                            ['feature_inbox_visible'].some(cb => featureDetails?.includes(cb)) && (
                                                <USBNavListItem data-testid="inbox-link">
                                                    <USBNavLink
                                                        href="#"
                                                        isActive={currentMenu === 'inbox'}
                                                        onClick={(e) => navClick(e, gotoInbox, { closeMainNav: true })}
                                                    >
                                                        Inbox
                                                    </USBNavLink>
                                                </USBNavListItem>
                                            )}

                                        {/* Contacts */}
                                        {(sessionStorage.getItem('remote_user') || userCheck !== 'employee') &&
                                            ['feature_contacts_visible'].some(cb => featureDetails?.includes(cb)) && (
                                                <USBNavListItem data-testid="contacts-link">
                                                    <USBNavLink
                                                        href="#"
                                                        isActive={currentMenu === 'contacts'}
                                                        onClick={(e) => navClick(e, gotoContacts, { closeMainNav: true })}
                                                    >
                                                        Contacts
                                                    </USBNavLink>
                                                </USBNavListItem>
                                            )}

                                        {/* Manage Users */}
                                        {(userCheck === 'employee' ||
                                            userCheck === 'portaladmin' ||
                                            servicingUserRole === 'siteadmin' ||
                                            servicingUserRole === 'vendorsiteadmin') &&
                                            permissionDetails?.includes('manageusers') && (
                                                <USBNavListItem data-testid="manageuser-link">
                                                    <USBNavLink
                                                        href="#"
                                                        isActive={currentMenu === 'manageuser'}
                                                        onClick={(e) => navClick(e, gotoManageUsers, { closeMainNav: true })}
                                                    >
                                                        Manage Users
                                                    </USBNavLink>
                                                </USBNavListItem>
                                            )}

                                        {/* Document Templates */}
                                        {!(permissionDetails?.includes('inbox') && !permissionDetails?.includes('portfolio')) && (
                                            <USBNavListItem data-testid="docTemplates-link">
                                                <USBNavLink
                                                    href="#"
                                                    isActive={currentMenu === 'doctemplates'}
                                                    onClick={(e) => navClick(e, gotoDocTemplates, { closeMainNav: true })}
                                                >
                                                    Document Templates
                                                </USBNavLink>
                                            </USBNavListItem>
                                        )}

                                        {/* Reports */}
                                        {userCheck === 'employee' && permissionDetails?.includes('reports') && (
                                            <USBNavListItem data-testid="reports-link">
                                                <USBNavSubTrigger>
                                                    Reports
                                                </USBNavSubTrigger>
                                                <USBNavSub>
                                                    <USBNavSubCloseButton>Back</USBNavSubCloseButton>
                                                    <USBText as="h2">Reports</USBText>
                                                    <USBNavList>
                                                        <USBNavListItem>
                                                            <USBNavLink href="#" className={'black-font'} onClick={(e) => gotoReport(e, '/Reports/CustomerAccessFilter')}>
                                                                Customer Access Report
                                                            </USBNavLink>
                                                        </USBNavListItem>
                                                        <USBNavListItem>
                                                            <USBNavLink href="#" className={'black-font'} onClick={(e) => gotoReport(e, '/Reports/Lookup')}>
                                                                Lookup Report
                                                            </USBNavLink>
                                                        </USBNavListItem>
                                                        <USBNavListItem>
                                                            <USBNavLink href="#" className={'black-font'} onClick={(e) => gotoReport(e, '/Reports/PortalSubmission')}>
                                                                Portal Submission
                                                            </USBNavLink>
                                                        </USBNavListItem>
                                                        <USBNavListItem>
                                                            <USBNavLink href="#" className={'black-font'} onClick={(e) => gotoReport(e, '/Reports/PSAFilter')}>
                                                                PSA Filter
                                                            </USBNavLink>
                                                        </USBNavListItem>
                                                        <USBNavListItem>
                                                            <USBNavLink href="#" className={'black-font'} onClick={(e) => gotoReport(e, '/Reports/VendorCompanyFilter')}>
                                                                Vendor Access
                                                            </USBNavLink>
                                                        </USBNavListItem>
                                                        <USBNavListItem>
                                                            <USBNavLink href="#" className={'black-font'} onClick={(e) => gotoReport(e, '/Reports/VendorUserFilter')}>
                                                                Vendor User
                                                            </USBNavLink>
                                                        </USBNavListItem>
                                                        {featureDetails?.includes('feature_enrollment_report') && (
                                                            <USBNavListItem>
                                                                <USBNavLink href="#" className={'black-font'} onClick={(e) => gotoReport(e, '/Reports/enrollmentReport')}>
                                                                    Enrollment Report
                                                                </USBNavLink>
                                                            </USBNavListItem>
                                                        )}
                                                    </USBNavList>
                                                </USBNavSub>
                                            </USBNavListItem>
                                        )}

                                        {/* Tools */}
                                        {userCheck === 'employee' &&
                                            ['tools'].some(item => permissionDetails?.includes(item)) && (
                                                <USBNavListItem data-testid="tools-link">
                                                    <USBNavSubTrigger>
                                                        Tools
                                                    </USBNavSubTrigger>
                                                    <USBNavSub>
                                                        <USBNavSubCloseButton>Back</USBNavSubCloseButton>
                                                        <USBText as="h2">Tools</USBText>
                                                        <USBNavList>
                                                            <USBNavListItem>
                                                                <USBNavLink href="#" className={'black-font'} onClick={(e) => gotoTool(e, '/FeatureFlags')}>
                                                                    Feature Flags
                                                                </USBNavLink>
                                                            </USBNavListItem>
                                                            {featureDetails?.includes('feature_requirements_visible') && (
                                                                <USBNavListItem>
                                                                    <USBNavLink href="#" className={'black-font'} onClick={(e) => gotoTool(e, '/AllRequirements')}>
                                                                        All Requirements
                                                                    </USBNavLink>
                                                                </USBNavListItem>
                                                            )}
                                                            <USBNavListItem>
                                                                <USBNavLink href="#" className={'black-font'} onClick={(e) => gotoTool(e, '/FeatureByCategory')}>
                                                                    Feature By Category
                                                                </USBNavLink>
                                                            </USBNavListItem>
                                                        </USBNavList>
                                                    </USBNavSub>
                                                </USBNavListItem>
                                            )}

                                        {/* Exit User — mobile (utility bar handles desktop) */}
                                        {sessionStorage.getItem('remote_user') && (
                                            <USBNavListItem
                                                display={{ base: null, lg: 'none' }}
                                            >
                                                <USBNavLink
                                                    href="#"
                                                    onClick={(e) => navClick(e, exitImpersonate, { closeMainNav: true })}
                                                >
                                                    Exit User
                                                </USBNavLink>
                                            </USBNavListItem>
                                        )}

                                    </USBNavList>
                                </USBNavBar>
                            </USBNavCollapse>
                        </USBColumn>
                        <USBColumn largeSpan={2} />
                    </USBGrid>
                </USBNavRoot>
            </header>
        </>
    );
};

export default NavMenu;